import { createContext } from "react";

const ContentContext = createContext({
  item: {},
  castings: [],
  smartlists: [],
  metadata: {},
  isDisabled: false,
});

export default ContentContext;
